// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
#    Colors
   ========================================================================== */
/*\$mainColor:#d40621;
\$alphaLight:rgba(#fff, .5);
\$alphaDark:rgba(#000, .5);
\$placeholderTextLight:rgba(#fff, .7);
\$placeholderTextDark:rgba(#000, .7);

\$textLight: #fff;
\$textDark: #404040;
\$textThemes:#d40621;*/
/* ################## */
/* ################## */
/* ################## */
/* ################## */
media-test-mini .testBox {
  background-color: var(--c_backgroundBox);
  border-radius: 4px;
  margin-bottom: 0px;
  transition: all 0.5s ease-in-out;
  box-sizing: border-box;
  position: relative;
  margin-bottom: 2px;
}
media-test-mini .testBox.js-visible {
  overflow: visible;
}
media-test-mini .testBox > div:not(.testEvaluation) {
  padding: 20px;
  display: flex;
  justify-content: space-between;
}
media-test-mini .testBox > div:not(.testEvaluation) h2.title {
  color: var(--c_textBody);
  font-weight: bold;
  font-size: 1.375em;
}
media-test-mini .testBox .inner {
  display: flex;
}
media-test-mini .testBox .inner .testIcon {
  width: 40px;
}
media-test-mini .testBox .btnWrapper {
  width: 260px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
media-test-mini .testBox .btnWrapper .btn {
  width: 120px;
}
media-test-mini .testBox .innerColumn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}
media-test-mini .testBox .portrait {
  width: 100px;
}
media-test-mini .testBox .switchContentHolder {
  position: relative;
  margin-left: var(--m_components);
}
media-test-mini .testBox .switchContentHolder .switchContent {
  width: 100%;
  transition: opacity 0.25s ease-in-out;
}
media-test-mini .testBox .statusIconArea {
  width: 20px;
  position: absolute;
  right: 20px;
}
media-test-mini .testBox .statusIconArea .statusIcon {
  width: 100%;
  transform: translateY(50%);
  opacity: 0;
  transition: opacity 0.25s ease-in-out;
}
media-test-mini .testBox .statusIconArea .statusIcon.svg_Check svg .fill {
  fill: #54ad54;
}
media-test-mini .testBox .statusIconArea .statusIcon.svg_Warning svg .fill {
  fill: var(--c_buttonDangerBackground);
}
media-test-mini .testBox .microphone_failed visiba-svg {
  width: 20px;
  margin-right: 10px;
}
media-test-mini .testBox .microphone_failed .fill {
  fill: var(--c_accentColor);
}
media-test-mini .testBox .microphone_failed .desc {
  color: var(--c_accentColor);
}
media-test-mini .testBox .iconWrapper {
  position: relative;
  width: 40px;
}
media-test-mini .testBox .iconWrapper .testIcon {
  width: 100%;
  position: relative;
  z-index: 2;
}
media-test-mini .testBox .iconWrapper .circlesWrapper {
  width: 100%;
  position: absolute;
  top: 20px;
}
media-test-mini .testBox .iconWrapper .circlesWrapper .circles {
  width: 100%;
  padding-bottom: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
media-test-mini .testBox .iconWrapper .circlesWrapper .circles .circle {
  background: rgba(var(--c_mainColorDark), 0.1);
  border-radius: 100%;
  width: 150%;
  height: 150%;
  position: absolute;
  top: -25%;
  left: -25%;
}
media-test-mini .testBox .iconWrapper .circlesWrapper .svgbg {
  background: #fff;
  border-radius: 100%;
  overflow: hidden;
  width: 92%;
  padding-bottom: 92%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
media-test-mini .testCamera .videoWrap {
  position: relative;
  border-radius: 100%;
  overflow: hidden;
  height: 0px;
  padding-bottom: 100%;
  transition: opacity 0.25s ease-in-out;
}
media-test-mini .testCamera .videoWrap .videoLoaderIcon {
  width: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
media-test-mini .testCamera .videoWrap video {
  max-width: unset;
}
media-test-mini .hide {
  opacity: 0;
}
media-test-mini .show {
  opacity: 1 !important;
  transition: opacity 0.25s 0.25s ease-in-out !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
